<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData" @uploadFile="uploadFile"></UPDATE>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import UPDATE from '@/components/page/update'
import axios from '@/utils/request'
import DateUtil from '@/utils/IM/tradeDataUtil'

export default {
  name: 'sleepingFollowupList',
  components: {
    FORM,
    tablePage,
    UPDATE
  },

  data() {
    return {
      queryData: {},
      updateData: {
        cols: [
          {
            title: '用戶列表',
            field: 'customerNumber',
            type: 11,
            action: Url.utils.uploadFile,
            downUrl: 'https://config.hteew.com/upload/model/沉睡客户模版.xlsx'
          },
          { title: '统计时间', field: 'time', type: 9, data: [], required: true }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          { click: window.$t('common.search') },
          { click: window.$t('common.import'), auth: 'analyse:sleepingfollowup:import' },
          { click: window.$t('common.export'), auth: 'analyse:sleepingfollowup:export' },
          { click: '初始化', auth: 'hide_btn_for_init' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.sleepingFollowList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { field: 'customerNumber', sWidth: '200px', title: '会员账号' },
          { field: 'name', sWidth: '200px', title: '姓名' },
          { field: 'mobilePhone', sWidth: '200px', title: '手机号码' },
          { field: 'email', sWidth: '200px', title: '邮箱' },
          { field: 'remark', sWidth: '200px', title: '后台客户维护标记' },
          { field: 'utm', sWidth: '200px', title: '媒介' },
          { field: 'activeDate', title: '激活时间' },
          { field: 'accountGroup', title: '账户组别' },
          { field: 'accountLevelCode', title: '用戶类型' },
          { field: 'accountStatusCode', title: '交易账户状态' },
          { field: 'paymentGatewayTags', title: '支付网关标记' },
          { field: 'payVerificationMark', title: '支付验证标记' },
          { field: 'depositTimes', title: '入金次数' },
          { field: 'depositAmount', title: '入金金额' },
          { field: 'withdrawalsTimes', title: '出金次数' },
          { field: 'withdrawalsAmount', title: '出金金额' },
          { field: 'netDeposit', title: '净入金' },
          { field: 'openSymbol', title: '开仓產品' },
          { field: 'openLots', title: '开仓手数' },
          { field: 'openTimes', title: '开仓次数' },
          { field: 'lastOpenDate', title: '最后开仓时间' },
          { field: 'closeLots', title: '平仓手数' },
          { field: 'closeTimes', title: '平仓次数' },
          { field: 'lastCloseDate', title: '最后平仓时间' },
          { field: 'profit', title: '盈亏' },
          { field: 'closeSymbol', title: '平仓产品' },
          { field: 'stime', title: '统计开始时间' },
          { field: 'etime', title: '统计结束时间' },
          { field: 'ctime', title: '创建 时间' },
          { field: 'uptime', title: '更新时间' },
          {
            field: 'type', title: '數據類型', render: (data, full) => {
              return (data === 1) ? '時間范围用户' : '导入用戶'
            }
          }
        ]
      }
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    uploadFile(col, result) {
      console.info(result)
      col.data = (result || []).join(',')
    },
    submit(model) {
      this.formatDate(model)
      this.dataChange(Url.sleeping.sleepingFollowImport, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('导入' == clickName || window.$t('common.import') == clickName) {
        this.$refs.childUpdate.open()
      } else if ('导出' == clickName || window.$t('common.export') == clickName) {
        download.exportExcel(Url.sleeping.sleepingFollowDown, data, 'A客管理')
      } else if ('init' == clickName) {
        this.init()
      }
    },

    init() {
      axios.get(Url.sleeping.sleepingFollowInit)
    },
    formatDate(data) {
      data.startTime = data.time[0]
      data.endTime = data.time[1]
    }
  },
  mounted() {
  }
}

</script>

